// AmazonReviewsBadge.jsx
import React from "react";

/**
 * Badge para abrir directamente la sección de reseñas de un producto en Amazon.es
 * Cumple políticas: enlaza a Amazon; no muestra estrellas/ratings ni texto de reseñas.
 *
 * Props:
 * - asin (string)        : ASIN del producto (por defecto B0DR7BGF7L)
 * - tag  (string)        : Tag de afiliado (opcional)
 * - label (string)       : Texto principal del botón (por defecto "⭐ Ver reseñas en Amazon")
 * - sublabel (string)    : Texto secundario (por defecto "Abrir en Amazon.es")
 * - className (string)   : Clases extra para estilos propios (opcional)
 * - style (object)       : Estilos inline (opcional)
 * - newTab (boolean)     : Abrir en pestaña nueva (por defecto true)
 * - unstyled (boolean)   : Si true, no aplica estilos por defecto
 */
export default function AmazonReviewsBadge({
  asin = "B0DR7BGF7L",
  tag,
  label = "⭐ Ver reseñas en Amazon",
  sublabel = "Abrir en Amazon.es",
  className = "",
  style,
  newTab = true,
  unstyled = false,
}) {
  const baseUrl = `https://www.amazon.es/dp/${asin}`;
  const url = `${baseUrl}${tag ? `?tag=${encodeURIComponent(tag)}` : ""}#customerReviews`;

  const defaultStyles = unstyled
    ? {}
    : {
        display: "inline-flex",
        flexDirection: "column",
        gap: "2px",
        padding: "10px 14px",
        borderRadius: "12px",
        textDecoration: "none",
        border: "1px solid rgba(0,0,0,.08)",
        boxShadow: "0 2px 8px rgba(0,0,0,.06)",
        background: "white",
        transition: "transform .08s ease, box-shadow .12s ease",
      };

  const titleStyle = unstyled ? {} : { fontWeight: 700, lineHeight: 1.2 };
  const subStyle = unstyled ? {} : { fontSize: ".85rem", opacity: 0.8, lineHeight: 1.1 };

  const target = newTab ? "_blank" : "_self";
  const rel = newTab ? "nofollow sponsored noopener noreferrer" : "nofollow sponsored";

  return (
    <a
      href={url}
      className={`amazon-reviews-badge ${className}`}
      style={{ ...defaultStyles, ...style }}
      target={target}
      rel={rel}
      aria-label="Ver reseñas de este producto en Amazon"
    >
      <span style={titleStyle}>{label}</span>
      {sublabel ? <span style={subStyle}>{sublabel}</span> : null}
    </a>
  );
}
